module.exports = __webpack_public_path__ + "assets/img/img-talk-03.d70186d5.jpg";